import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

import './confirmation-dialog.styl';

function ConfirmationDialog({
  title,
  content,
  onClose,
  onConfirm,
  confirmButtonLoading = false,
}) {
  return (
    <Portal>
      <div className="confirmation-dialog__backdrop">
        <div className="confirmation-dialog">
          <h3 className="confirmation-dialog__title">
            {title}
            <Button
              className="confirmation-dialog__title__close"
              icon={faClose}
              layout="ghost"
              color="black"
              hover={false}
              onClick={onClose}
              size="16px"
            />
          </h3>
          <div className="confirmation-dialog__content">
            {content}
          </div>
          <div className="confirmation-dialog__buttons">
            <Button
              className="confirmation-dialog__buttons__confirm"
              onClick={onConfirm}
              isLoading={confirmButtonLoading}
            >
              Bevestigen
            </Button>
            <Button
              className="confirmation-dialog__buttons__cancel"
              onClick={onClose}
              layout="outlined"
            >
              Annuleren
            </Button>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default ConfirmationDialog;